import { Equipe } from "./equipe";
import { Operation } from "./operation";
import { Probleme } from "./probleme";
import { Projet } from "./projet";
import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { RotationProbleme } from "./rotationProbleme";
import { Tir } from "./tir";

export class Rotation {
  rotationId: number;
  date: Date;
  duree: number;
  equipeId: number;
  tirId: number;
  projetId: number;
  equipe: Equipe;
  //tir: Tir;
  siteId: number;
  projet: Projet;
  operations: Operation[];
  rotationProblemes: RotationProbleme[];
  nbProblemes: number;
  nbOperations: number;
  problemes: Probleme[];

  getProprietesAffichees(rotationProjet = true) {
    let tab: ProprieteAffichee[] = [];
    if (rotationProjet)
     // tab.push(new ProprieteAffichee('tir', 'GLOBAL.TIR', 'nom'));
    tab.push(new ProprieteAffichee('date', 'DONNEE_SUIVI_OP.DATE', '', new CustomAffichage(TypePropriete.Date)));
    tab.push(new ProprieteAffichee('duree', 'GLOBAL.DURATION', '', new CustomAffichage(TypePropriete.Duration)));
    tab.push(new ProprieteAffichee('equipe', 'DONNEE_SUIVI_OP.EQUIPE', 'nom'));
    tab.push(new ProprieteAffichee('nbOperations', 'DONNEE_SUIVI_OP.OPERATIONS', '', new CustomAffichage(TypePropriete.Number)));
    tab.push(new ProprieteAffichee('nbProblemes', 'DONNEE_SUIVI_OP.PROBLEMES', '', new CustomAffichage(TypePropriete.Number)));
    return tab;
  }
}
